(function(){
  'use strict';

  function afterSuccess(url){
    if (!url) return false;
    return /\/cart\/(add|change|update)\.js(?:\?|$)/i.test(url);
  }

  function openAndRefresh(){
    setTimeout(function(){
      if (window.nmCartDrawer && typeof window.nmCartDrawer.open === 'function') {
        window.nmCartDrawer.open();
        if (typeof window.nmCartDrawer.refresh === 'function') {
          setTimeout(function(){ window.nmCartDrawer.refresh(); }, 80);
        }
      }
    }, 40);
  }

  document.addEventListener('nm:cart:added', openAndRefresh);

  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function(input, init){
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return origFetch.apply(this, arguments).then(function(resp){
        if (resp && resp.ok && afterSuccess(url)) openAndRefresh();
        return resp;
      });
    };
  }

  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url){
      this.__nmCartUrl = url || '';
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(){
      this.addEventListener('load', function(){
        if (this.status >= 200 && this.status < 300 && afterSuccess(this.__nmCartUrl)) {
          openAndRefresh();
        }
      });
      return origSend.apply(this, arguments);
    };
  }

  document.addEventListener('click', function(e){
    var trigger = e.target && e.target.closest && e.target.closest('[data-nm-cart-trigger]');
    if (!trigger) return;
    e.preventDefault();
    if (window.nmCartDrawer && typeof window.nmCartDrawer.toggle === 'function') {
      window.nmCartDrawer.toggle();
    }
  }, true);
})();
